import React, { useState, useEffect, useCallback } from 'react';

const backgrounds = [
  '/main-bg-morning.png',
  '/main-bg-day.png',
  '/main-bg-afternoon.png',
  '/main-bg-golden.png',
  '/main-bg-evening.png',
  '/main-bg-night.png',
];

const ScrollBackground = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleScroll = useCallback(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;
    setScrollProgress(progress);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const segmentCount = backgrounds.length;
  const scaled = scrollProgress * (segmentCount - 1);
  const activeIndex = Math.min(Math.floor(scaled), segmentCount - 2);
  const blend = scaled - activeIndex;

  return (
    <div className="fixed inset-0 z-0" style={{ pointerEvents: 'none' }}>
      {backgrounds.map((src, i) => {
        let opacity = 0;

        if (i === activeIndex) {
          opacity = 1 - blend;
        } else if (i === activeIndex + 1) {
          opacity = blend;
        } else if (i < activeIndex) {
          opacity = 0;
        } else if (i > activeIndex + 1) {
          opacity = 0;
        }

        if (scrollProgress <= 0 && i === 0) opacity = 1;
        if (scrollProgress >= 1 && i === segmentCount - 1) opacity = 1;

        return (
          <div
            key={src}
            className="absolute inset-0 bg-cover bg-center bg-no-repeat will-change-[opacity]"
            style={{
              backgroundImage: `url(${src})`,
              opacity,
              transition: 'opacity 0.15s linear',
            }}
          />
        );
      })}
    </div>
  );
};

export default ScrollBackground;
